import { render, staticRenderFns } from "./MoedaSetting.vue?vue&type=template&id=5deadab8"
import script from "./MoedaSetting.vue?vue&type=script&lang=js"
export * from "./MoedaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports